export const desktopViewportStyle = {
  height: '100dvh',
  inset: 0,
  minHeight: 0,
  overflow: 'hidden',
  position: 'fixed',
  width: '100%',
} as const

export const desktopSidebarStyle = {
  height: '100%',
  overflow: 'hidden',
} as const

export const scrollableMenuStyle = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overscrollBehavior: 'contain',
} as const

export const desktopWorkspaceStyle = {
  height: '100%',
  minHeight: 0,
  minWidth: 0,
  overflow: 'hidden',
} as const

export const scrollableContentStyle = {
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  overflow: 'auto',
  overscrollBehavior: 'contain',
} as const
